import type { HormoneProfile } from "../profile";
import { OFFER } from "../offer";
import { assetUrl, PRODUCT_IMAGE } from "../assets";

/**
 * Structure copies manly/report/ProductPage.tsx exactly: kicker, heading,
 * bold connector, bold product paragraph, hero, three beats, note, sticky
 * CTA. Content stays this quiz's own: the connector is about disclosure (the
 * loophole the whole funnel is built on), the beats are ingredient honesty
 * rather than odor performance, and the note carries the 60-day guarantee.
 * Deliberately NO diagnosis stats up top (client cut the congruency strip)
 * and no discount language anywhere in this funnel.
 */
export function ProductPage({
  profile, onNext,
}: { profile: HormoneProfile; onNext: () => void }) {
  return (
    <>
      <div className="qk-manly-kicker">The fix</div>
      <h2>Start with the wash.</h2>
      <p>
        <strong>
          Where {profile.brandLabel} writes "fragrance" and stops, Manly names everything.
        </strong>
      </p>

      <p>
        <strong>The Natural Body Wash.</strong> The only thing he uses head to toe, every day, on
        all that thin skin at once. Take the phthalates out of that one bottle and you have cut
        more daily exposure than the shampoo and deodorant put together.
      </p>

      {/* Same asset the live sibling ships (assets.ts: shared /manly/ directory),
          so its intrinsic size and its baked-in reported-results overlay are
          identical here. */}
      <img
        className="qk-manly-hero"
        src={assetUrl(PRODUCT_IMAGE)}
        alt="Manly Natural Body Wash in Citrus Breeze, with its reported results: 94% total odor neutralization for up to 24 hours, 91% said their skin felt hydrated and smooth, 89% noticed a significant reduction in skin irritation and back-ne flare-ups"
        width={900}
        height={902}
        loading="lazy"
      />

      <div className="qk-manly-beats">
        <div className="qk-manly-beat">
          <span aria-hidden>{"\u{1F6E1}️"}</span>
          <div>
            <b>Hormone-safe by design.</b> Zero SLS, zero synthetic fragrance, zero parabens, zero
            phthalates.
          </div>
        </div>
        <div className="qk-manly-beat">
          <span aria-hidden>{"\u{1F33F}"}</span>
          <div>
            <b>Named, not hidden.</b> Kakadu Plum, Lemon Myrtle, prebiotics, a sulfate-free coconut
            lather. Every ingredient printed on the label, nothing behind the word "fragrance".
          </div>
        </div>
        <div className="qk-manly-beat">
          <span aria-hidden>{"\u{1F52C}"}</span>
          <div>
            <b>Your receipt at week 2.</b> The smell goes. Not masked, gone. It is the one change
            you can verify yourself without a lab.
          </div>
        </div>
      </div>

      <p className="qk-manly-note">
        <strong>{OFFER.guarantee.lead}</strong> {OFFER.guarantee.detail}
      </p>

      <button type="button" className="qk-cta qk-manly-cta-sticky" onClick={onNext}>
        Get his body wash
      </button>
    </>
  );
}
